<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img data-src="/assets/manufacture/transmission/pizhou/pz.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    变速器邳州工厂
                </div>
                <div class="manufacture-t2">
                    位于江苏省徐州市邳州市，主要生产DHT-1、DHT-2、DHT-3、 DHT-3L及150KW电桥总成<br />
                    掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，覆盖传统DCT、AT变速器、混合动力专用变速器、纯电动驱动总成全动力类型产品布局<br />
                    投产至今获得2015年度江苏省先进级职能工厂、2016年度徐州市创新型中小企业、省五星级上云企业、国家级高新技术企业等多项荣誉，多项工艺处于行业领先。
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                DHT4线
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    
                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                电机热装
                            </div>
                            <div class="destils">
                                ① 电机采用热装工艺<br />
                                ② 壳体通过中频加热至150度，机器人精准抓取两个电机的定子放到壳体中，经过空调冷却至室温，实现壳体将电机牢牢抱紧，即定子的固定功能
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz1-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                自动上料装配
                            </div>
                            <div class="destils">
                                壳体定位销、油封、螺栓类零部件全部采用自动化料仓上料，设备自动机器手自动上料完成装配
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz1-2.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                EOL测试
                            </div>
                            <div class="destils">
                                ① 采用EOL全自动测试台，从机械、电机、电器、软件、NVH、控制策略等项目，开展全面的功能和安全测试，确保发动机传动部分平滑静谧，确保电机驱动部分安全可靠<br />
                                ② 测试设备，在每台变速器总成出厂之前，完全模拟发动机及整车驾驶工况，100%进行全功能、全项目测试，NVH测试<br />
                                ③ 采用最先进Discom测试系统，进行分析判断，确保交付客户安全可靠、高品质的产品
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz1-3.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                转线与激光打标
                            </div>
                            <div class="destils">
                                ① 采用了高位机器人和激光打标技术<br />
                                ② 通过机器人将桁架辊道上的变速箱抓取，并送到激光打标机位置进行打标，同时配备了吸雾装置，将烟尘进行吸附过滤，保证了产品的清洁度和产品质量
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz1-4.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                电机转线及离合器壳体自动装配
                            </div>
                            <div class="destils">
                                ① 采用电机转线及离合器壳体自动装配的工艺<br />
                                ② 物料通过小车放置在线边，通过上方的3D相机识别零部件的精确位置，传输给机器人，机器人精准的抓取物料实现自动装配，彻底消除了员工搬运壳体的劳动强度
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz1-5.jpg" alt="">
                        </div>
                    </div>
                    
                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                轴系自动拼装
                            </div>
                            <div class="destils">
                                轴系线自动拼装工位，通过夹具定位，将轴串自动拼接，使用2台机器人交互协作抓取，实现精确定位，自动装配至变速器内
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz1-6.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                齿轮热压
                            </div>
                            <div class="destils">
                                发动机主动齿轮通过AtecD中频加热，并采用DSP进行全数字式精确控制，设备自动取料进行高精度压装，经过空调冷却至室温
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz1-7.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                DHT混动变速器线
                            </div>
                            <div class="destils">
                                DHT混动变速器线，整线自动化率63%，防错覆盖率100%，线体以“智能化、数字化、柔性化”的理念进行设计，分为电机线、轴齿线、装配线、测试线、分装线五大区域，整体布局为长方形，呈L型装配和L型物流体现方式，实现了线体运转与物流配送敏捷、精准、高效
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz1-8.jpg" alt="">
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                DHT6线
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                EOL测试
                            </div>
                            <div class="destils">
                                ① 采用测试台架，进行100%全功能，性能测试，自动化率100%，设备可动率达到95%以上<br />
                                ② 测试项目覆盖变速器自学习，传感器功能检测，换挡功能检测，驻车功能检测，离合器性能检测，NVH，拖曳扭矩等变速器全性能检测，采用real-time系统通过对测试过程中质量数据分析实现变速器品质判定。通过NVRAM的数据记录，可实现对自动变速器全生命周期的质量跟踪和售后服务，从而形成了DHT自动变速器生命全过程质量控制和管理保障体系<br />
                                ③ 测试数据存储在专有的服务器中，可做到质量数据的追溯，同时服务器采用双机热备及SMTP（简单邮件传输协议）保证服务器平稳运行
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz2-2.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                电机转线及离壳压装
                            </div>
                            <div class="destils">
                                ① 实现壳体上线，3D精准识别，自动抓取<br />
                                ② 工位作业内容：机器人从料车上自动抓取离合器壳体至工作位，并自动拆垛<br />
                                ③ 技术应用：采用3D视觉系统 + 机器人<br />
                                ④ 技术亮点：3D检测，建立工件空间坐标，机器手依据空间坐标精准抓取，并实现拆垛，提升自动化，减少人工
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz2-3.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                协助机器人自动拧紧
                            </div>
                            <div class="destils">
                                ① 采用协作机器人自动拧紧<br />
                                ② 工位作业内容：变速器零部件拧紧<br />
                                ③ 技术应用：采用协作机器人自动拧紧<br />
                                ④ 技术亮点：协作机器人安全作业，人员可干预，减少操作人员，及维修难度
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz2-4.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                壳体测量
                            </div>
                            <div class="destils">
                                ① 实现壳体及轴系自动测量<br />
                                ② 工位作业内容：测量壳体轴承位等高度尺寸<br />
                                ③ 技术应用：高精度传感器（精度0.001，分辨率0.0001），锥轴承动态测量<br />
                                ④ 技术亮点：全自动工位，集成壳体和轴系，保证与产品状态一致，动态测量进一步提高测量精度，设备重复性满足Cg≥1.67
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz2-5.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                轴系合装
                            </div>
                            <div class="destils">
                                ① 实现轴系拼装及入箱<br />
                                ② 工位作业内容：轴系自动转线，并完成拼装入箱<br />
                                ③ 技术应用：六轴同步入箱<br />
                                ④ 技术亮点：机器人搬运，拨叉、轴齿拼装后，定位精度高，机器人自动完成6轴入箱
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz2-6.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                壳体合箱
                            </div>
                            <div class="destils">
                                ① 实现壳体合箱<br />
                                ② 工位作业内容：机器人抓取电机分总成完成离变壳合箱<br />
                                ③ 技术应用：自动啮合<br />
                                ④ 技术亮点：机器人抓取电机分总成上料，合装机进行电机轴自动旋转，完成花键啮合及离变壳合箱
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz2-7.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                试漏
                            </div>
                            <div class="destils">
                                ① 采用总成自动试漏工艺<br />
                                ② 工位作业内容：总成试漏<br />
                                ③ 技术应用：全自动封堵及测试<br />
                                ④ 技术亮点：全自动封堵，并完成测试，采用国际一线品牌试漏仪，重复精度Cg≥1.67
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz2-8.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                总成外观检测
                            </div>
                            <div class="destils">
                                ① 采用相机外观检查<br />
                                ② 工位作业内容：总成外观照相检查<br />
                                ③ 技术应用：协作机器人、视觉检测+暗室<br />
                                ④ 技术亮点：全自动完成外观检查，保证产品出厂质量
                            </div>
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                检测能力
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    
                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                精密测量室
                            </div>
                            <div class="destils">
                                设备：全自动二维影像仪, 形状测量仪,轮廓仪, 齿轮测量中心<br />
                                能力：快速进行几何尺寸测量及符合性评价和齿轮傅里叶检测及符合性评价
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz3-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                清洁度分析室
                            </div>
                            <div class="destils">
                                环境：恒温恒湿空调及微正压系统<br />
                                设备：压力喷射清洗机、超声波清洗机、电干燥箱、电子天平、颗粒度分析仪、油液过滤系统<br />
                                能力：快速从零部件和油液中国收集污染物，并进行扫描分析

                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz3-2.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                三坐标测量室
                            </div>
                            <div class="destils">
                                设备：17台蔡司三坐标测量设备（精度：1.2微米）<br />
                                能力：全面的几何尺寸与公差测量，包括：圆度/圆柱度/平行度/垂直度/位置度/角度/粗糙度
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz3-3.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                金相实验室
                            </div>
                            <div class="destils">
                                设备：研磨/抛光机/镶嵌机/切割机/硬度测试仪（布氏, 洛氏, 维氏, 显微维氏）<br />
                                能力：表面/心部硬度测试/硬化层深/显微组织分析

                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz3-4.jpg" alt="">
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>


    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: '变速器邳州工厂 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'manufacture/tr/pizhou.html'
};

import { createApp } from 'vue';
import App from './pizhou.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./pizhou.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
